/* global axios */
import ApiClient from './ApiClient';

class CommercialCatalogAPI extends ApiClient {
  constructor() {
    super('commercial_catalog/items', { accountScoped: true });
  }

  list(params) {
    return axios.get(this.url, { params });
  }

  save(item) {
    const payload = { commercial_catalog_item: item };
    return item.id ? this.update(item.id, payload) : this.create(payload);
  }
}

export default new CommercialCatalogAPI();
